import { styled, keyframes } from '@compiled/react';

import { N800, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { h800Compiled } from '@confluence/typography-placeholder';

const shakeAnimation = keyframes({
	'0%, 100%': {
		transform: 'translateX(0)',
	},
	'20%, 60%': {
		transform: 'translateX(-10px)',
	},
	'40%, 80%': {
		transform: 'translateX(10px)',
	},
});

type EditorTitleTextAreaProps = {
	shouldAnimate: boolean;
	isTitleCenterAligned?: boolean;
	isCustomSitesPageTitleFFOn?: boolean;
};

// TODO MODES-4231 Convert EditorTitleTextArea from styled to xcss once xcss supports keyframes
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EditorTitleTextArea = styled.textarea<EditorTitleTextAreaProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	...h800Compiled,
	animationName: shakeAnimation,
	animationTimingFunction: 'ease-in-out',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	animationDuration: (props: EditorTitleTextAreaProps) => (props.shouldAnimate ? '1000ms' : '0ms'),
	backgroundColor: 'inherit',
	marginTop: 0,
	fontWeight: 'normal',
	fontFamily:
		'inherit' /* fixing: default styles of FF for form elements overriding styles of body/html */,
	height: 'auto',
	display: 'block',
	border: 'none',
	textOverflow: 'ellipsis',
	resize: 'none',
	overflow: 'hidden',
	padding: 0,
	whiteSpace: 'pre-wrap',
	boxSizing: 'border-box',
	margin: 'auto',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	textAlign: ({ isTitleCenterAligned, isCustomSitesPageTitleFFOn }) =>
		isTitleCenterAligned && isCustomSitesPageTitleFFOn ? 'center' : 'initial',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:not(:disabled)': {
		color: token('color.text', N800),
	},
	'&:disabled': {
		color: token('color.text.disabled', N90),
		background: 'transparent' /* fixing: disabled styles of FF cause a grey background */,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&::-ms-clear': {
		display: 'none',
	},
	'&:focus': {
		outline: 'none',
	},
	'&:required, &:invalid': {
		boxShadow: 'none',
	},
	'&::placeholder': {
		color: token('color.text.subtlest', N90),
		opacity: 1 /* firefox inputfield colour fix*/,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		textAlign: ({ isTitleCenterAligned }) => (isTitleCenterAligned ? 'center' : 'initial'),
	},
});
